import { auth } from '../firebase';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

/**
 * Função helper para fazer requests autenticados
 */
async function authenticatedRequest(endpoint, options = {}) {
    try {
        // Obter token do usuário atual
        const user = auth.currentUser;
        if (!user) {
            throw new Error('Usuário não autenticado');
        }

        const token = await user.getIdToken();

        // Fazer request com token
        const response = await fetch(`${API_URL}${endpoint}`, {
            ...options,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
                ...options.headers,
            },
        });

        // Verificar se a resposta tem conteúdo antes de parsear JSON
        const contentType = response.headers.get('content-type');
        let data = null;

        if (contentType && contentType.includes('application/json')) {
            const text = await response.text();
            if (text) {
                data = JSON.parse(text);
            }
        }

        if (!response.ok) {
            // Se não conseguiu parsear JSON, usar mensagem genérica
            const errorMessage = data?.error?.message ||
                                data?.message ||
                                `Erro HTTP ${response.status}: ${response.statusText}`;
            throw new Error(errorMessage);
        }

        return data;
    } catch (error) {
        console.error('API Error:', error);
        throw error;
    }
}

/**
 * API de Pagamentos
 */
export const PaymentsAPI = {
    /**
     * Criar preferência de pagamento no Mercado Pago
     */
    createPreference: async (plan, userId) => {
        return authenticatedRequest('/api/payments/create-preference', {
            method: 'POST',
            body: JSON.stringify({ plan, userId }),
        });
    },

    /**
     * Consultar status de um pagamento
     */
    getPaymentStatus: async (paymentId) => {
        return authenticatedRequest(`/api/payments/status/${paymentId}`);
    },
};

/**
 * API de Assinaturas
 */
export const SubscriptionsAPI = {
    /**
     * Buscar informações da assinatura do usuário
     */
    getSubscription: async (userId) => {
        return authenticatedRequest(`/api/subscriptions/${userId}`);
    },

    /**
     * Cancelar assinatura (downgrade para básico)
     */
    cancelSubscription: async (userId, previousPlan) => {
        return authenticatedRequest('/api/subscriptions/cancel', {
            method: 'POST',
            body: JSON.stringify({ userId, previousPlan }),
        });
    },

    /**
     * Atualizar plano do usuário
     */
    updatePlan: async (userId, newPlan, subscriptionStatus = 'active') => {
        return authenticatedRequest('/api/subscriptions/update-plan', {
            method: 'POST',
            body: JSON.stringify({ userId, newPlan, subscriptionStatus }),
        });
    },

    /**
     * Buscar histórico de pagamentos
     */
    getPaymentHistory: async (userId) => {
        return authenticatedRequest(`/api/subscriptions/${userId}/payment-history`);
    },
};

/**
 * Health check da API
 */
export const healthCheck = async () => {
    try {
        const response = await fetch(`${API_URL}/api/health`);
        return await response.json();
    } catch (error) {
        console.error('Health check failed:', error);
        throw error;
    }
};
